import React from 'react';
import PropTypes from 'prop-types';
import TwoNumberFields from './TwoNumberFields';

const MedianEF = (props) => {
  return <TwoNumberFields labels={{ first: 'Median', second: 'Error Factor' }} {...props} />;
};

MedianEF.propTypes = {
  index: PropTypes.number.isRequired,
  selected: PropTypes.arrayOf(Number).isRequired,
  onUpdate: PropTypes.instanceOf(Function).isRequired,
  onRemove: PropTypes.instanceOf(Function).isRequired,
};

export default MedianEF;
